<template>
  <div id="home">
    <!-- <transition name="fade">
    </transition> -->
    <Details :project="hoverProject" v-if="hoverProject != null && this.$route.path == '/work' && !isMobile"/>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" v-keep-scroll-position :isMobile="isMobile" :project="hoverProject" :allProjects="allProjects"></router-view>
        </keep-alive>
        <!-- // Non cache component jump page -->
        <router-view v-if="!$route.meta.keepAlive" :isMobile="isMobile"></router-view>
  </div>
</template>

<script>
import Details from '@/components/Details.vue'
import { EventBus } from '../EventBus.js';

export default {
  name: 'Home',
  components: {
    Details
  },
  props: ['water', 'isMobile'],
  data() {
    return {
      enterProject: null,
      hoverProject: null,
      selectedProject: null,
      allProjects: null,
      url: process.env.VUE_APP_VPS_URL
    }
  },
  created() {
  var selfobject = this;
  this.$http.get(selfobject.url + '/homepage-projects')
    .then(function (response) {
      selfobject.allProjects = response["data"].projects;
    })
  },
  mounted() {
    let VueThis = this;

    EventBus.$on('image-hover', project => {
      if (project != "leave") {
        // VueThis.showWater = true;
        VueThis.hoverProject = project;
      } else {
        VueThis.hoverProject = null;
        // VueThis.showWater = false;
      }
    });

    EventBus.$on('project-selection', project => {
        VueThis.selectedProject = project;
        VueThis.hoverProject = null;
    });

    EventBus.$on('close', function() {
        VueThis.enterProject = false;
        VueThis.selectedProject = null;
        // VueThis.showWater = false;
    });
  },
  methods: {
    hideWater() {
      window.console.log("hide water");
      this.showWater = false;
    }
  }
}
</script>

<style scoped>
#home {
  @apply top-0 absolute w-full h-full;
}

.enterWL {
    cursor: pointer;
    z-index:100;
}

</style>
